import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ResetPasswordContext } from './context'
import { ResetPasswordControllerProps } from './types'
import { useApi } from '@hooks/api'
import { ResetPasswordFormType } from '@type/reset_password_form_type'
import { AuthApi } from '@services/api/auth_api'
import { useAuth } from '@hooks/auth'

export const ResetPasswordController = (
  props: ResetPasswordControllerProps
): JSX.Element => {
  const navigate = useNavigate()

  const api = useApi()
  const auth = useAuth()
  const { token } = useParams<{ token: string }>()
  const [loading, setLoading] = React.useState<boolean>(false)
  const [error, setError] = React.useState<any | undefined>(undefined)

  const navToLogin = () => {
    navigate('/')
  }

  const handleSubmit = (formData: Partial<ResetPasswordFormType>) => {
    setError(undefined)
    setLoading(true)
    api
      .instanceOf<AuthApi>(AuthApi)
      .resetPassword({ ...formData, token: String(token) })
      .then((response) => auth.authenticate(response))
      .catch((error) => setError(error.response.data))
      .finally(() => setLoading(false))
  }

  const state = {
    error,
    loading,
    navToLogin,
    handleSubmit,
  }
  return (
    <ResetPasswordContext.Provider value={state}>
      {props.children}
    </ResetPasswordContext.Provider>
  )
}
